module.exports = __webpack_public_path__ + "img/matic.78bf8d48.svg";